<section class="d-flex flex-column align-items-center gap-5 mt-4 mb-5">
  <div class="wrapper" *ngFor="let glimpse of glimpses" (click)="openDialog(glimpse.number)">
    <video [autoplay]="true" [loop]="true" [muted]="true" playsinline webkit-playsinline class="video point" [src]="glimpse.video">
      Your Browser Doesn't Support Video Playback
    </video>
    <div class="text point">
      <p class="smallHead mt-2 headingBS"><span>Master</span> class by</p>
      <h3 class="mb-2">{{ glimpse.title }}</h3>
      {{ transform(glimpse.detail) }}
    </div>
  </div>
</section>
